<template>
  <div style="background:#eee;padding: 20px">
    <Card :bordered="false">
      <p slot="title" style="font-size: 18px;font-weight: bold;">特别声明</p>
      <div id="smcontent">
      <p>基于互联网和计算机技术的现状（包括但不限于网络传输技术、信息源、代码技术、程序技术、文字识别处理技术等）及可能引发的技术缺陷与瑕疵的理解与认同，任何使用“众智云擎”的用户（以下简称“用户”）均认可并接受下述情形：
      </p>
      <p>1.“众智云擎”是基于互联网提供服务的，因此，基于网络运营商的原因，可能造成用户访问速率下降。</p>
      <p>2. 由于配合政府相关部门的工作，可能造成用户无法访问“众智云擎”。</p>
      <p>3. 因自然原因或者政治因素等不可抗力的原因，用户可能无法访问使用“众智云擎”，在不可抗力原因消除后，“众智云擎”服务供应商需尽快修复系统供用户使用并相应延长使用时间。 </p>
      <p>4.“众智云擎”及其服务供应商在其能力所及之范围内尽力保护用户使用“众智云擎”过程中的计算机安全，但由于互联网的开放性、风险性以及技术缺陷，用户在使用“众智云擎”的过程中，依然存在可能遭受第三方计算机病毒、恶意软件、恶意程序、恶意代码等侵害的风险。</p>
      <p>5.“众智云擎”的信息服务内容来源于互联网，通过底层架构、逻辑结构的设计，经计算机技术与人工共同筛选、判断、复核， 尽量确保信息的准确、完整、及时，但基于技术与人力的现状，仍无法对信息内容的完整性与准确性做出绝对性承诺。</p>
      <p>6.“众智云擎”的信息服务内容来源于互联网，不代表任何“众智云擎”及其服务供应商、关联方的意见，也不构成任何“众智云擎”及其服务供应商、关联方的建议。</p>
      <p>7.试用体验用户享50次文件访问权限。</p>
      <p>因上述情形，“众智云擎”及其服务供应商、关联方不承担用户任何直接或者间接损失，用户表示接受与理解。</p>
      <p>众智云擎用户不得以任何方式侵害众智云擎及其服务供应商、关联方的权益。</p>
    </div>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'statement',
  data() {
    return {

    }
  },
  mounted() {},
  methods: {

  }
}

</script>
<style scoped>
  #smcontent > p{
    margin: 10px;
    line-height: 20px;
    font-size:14px;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
</style>
